'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import { useState } from 'react';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TDynamicData } from '../../types/dynamic-data';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';

export function ProjectGallery({ project }: { project: TDynamicData }) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className="flex w-full flex-col items-start justify-start gap-6 sm:max-w-[584px] md:gap-8">
        {project.fields[0]?.images?.map((image, index) => (
          <Image
            onClick={handleOpenGallery(project.fields[0]?.images, index)}
            key={image.id}
            src={image.url}
            alt={resolveImageAlt(image, undefined)}
            width={0}
            height={0}
            className="h-auto w-full cursor-pointer overflow-hidden rounded-[32px] object-cover object-center"
            sizes="(min-width: 768px) 50vw, 100vw"
          />
        ))}
      </div>
    </>
  );
}
